var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "theme-container" },
    [
      _c(
        "div",
        { staticClass: "left-container" },
        [
          _c(
            "el-scrollbar",
            { staticClass: "left-scrollbar-container" },
            [
              _c("p", { staticClass: "theme-title mb10" }),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.enable,
                            callback: function ($$v) {
                              _vm.enable = $$v
                            },
                            expression: "enable",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              directives: [
                                {
                                  name: "removeAriaHidden",
                                  rawName: "v-removeAriaHidden",
                                },
                              ],
                              staticClass: "mb-10",
                              staticStyle: { width: "100%" },
                              attrs: { label: 0, border: "" },
                              on: { change: _vm.handleChangeTheme },
                            },
                            [_vm._v(" 默认外观 ")]
                          ),
                          _c(
                            "el-radio",
                            {
                              directives: [
                                {
                                  name: "removeAriaHidden",
                                  rawName: "v-removeAriaHidden",
                                },
                              ],
                              staticStyle: { width: "100%", margin: "0" },
                              attrs: { label: 1, border: "" },
                              on: { change: _vm.handleChangeTheme },
                            },
                            [_vm._v(" 自定义外观 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.enable == 1
                    ? _c(
                        "el-col",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            display: "flex",
                            "justify-content": "center",
                            "align-items": "center",
                            "flex-direction": "column",
                          },
                          attrs: { span: 24 },
                        },
                        _vm._l(_vm.defineList, function (item, i) {
                          return _c(
                            "div",
                            {
                              key: i,
                              staticClass: "page-type-btn",
                              class: {
                                "page-type-btn-active":
                                  _vm.activeDefinePage["pageKey"] ===
                                  item.pageKey,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleClickDefinePage(item)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(item.pageLabel) + " ")]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ],
                1
              ),
              false
                ? [
                    _c(
                      "el-row",
                      { attrs: { gutter: 5 } },
                      _vm._l(_vm.styleList, function (item) {
                        return _c(
                          "el-col",
                          {
                            key: item.key,
                            attrs: {
                              span: 4,
                              xl: 4,
                              lg: 4,
                              md: 8,
                              sm: 8,
                              xs: 10,
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "style-btn",
                                class: {
                                  "style-btn-active":
                                    _vm.activeStyle === item.key,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.activeStyleHandle(item)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.label) + " ")]
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 5 } },
                      _vm._l(_vm.themeList, function (t) {
                        return _c(
                          "el-col",
                          {
                            key: t.id,
                            staticClass: "theme-img-view",
                            attrs: { span: 8 },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.activeThemeHandle(t)
                              },
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                class: {
                                  "head-list-view-select":
                                    _vm.activeTheme.id === t.id,
                                },
                                staticStyle: { height: "100px" },
                              },
                              [
                                _c(
                                  "el-image",
                                  {
                                    staticClass: "head-list-img",
                                    class: {
                                      "head-list-img-active":
                                        _vm.activeTheme.id === t.id,
                                    },
                                    attrs: { src: t.headImgUrl, fit: "cover" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "image-slot",
                                        attrs: { slot: "error" },
                                        slot: "error",
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-picture-outline",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c("pre-view", {
        key: _vm.projectFormKey,
        ref: "preViewRef",
        attrs: { "form-key": _vm.formKey },
        on: { "hook:mounted": _vm.pvMount },
      }),
      _c(
        "div",
        { staticClass: "right-container" },
        [
          _c("user-theme", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.enable === 0,
                expression: "enable === 0",
              },
            ],
            ref: "userTheme",
            attrs: { formKey: _vm.formKey },
            on: { handleChangeFormKey: _vm.handleChangeFormKey },
          }),
          _c("define-theme", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.enable === 1,
                expression: "enable === 1",
              },
            ],
            ref: "defineTheme",
            attrs: {
              defineFormThemeProp: _vm.defineFormThemeProp,
              formKey: _vm.formKey,
              activeDefinePage: _vm.activeDefinePage.pageKey,
            },
            on: { save: _vm.saveSuccessFunc },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }